export enum EOrderStatus {
    CREATED = "created",
    REJECTED = "rejected",
    APPROVED = "approved",
}